<app-metric-card
  [title]="cardTitle"
  [currentValue]="closedTodayTicketData().value"
  [hidePrevious]="true"
  [hideComparison]="true"
  [isLoading]="isLoading()"
>
</app-metric-card>
